import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import clsx from "clsx";
import { IoMdArrowDropdown } from "react-icons/io";
import { useNavigate } from "react-router";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { useRouter } from "@/app/hooks/useRouter";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { ICartFilterBody } from "@/api_framework/api_modals/Cart";
import { useCartListAPI } from "@/app/hooks/api_hooks/Cart/useCartListAPI";
import RBACFlag from "@/app/components/core/RBACFlag";

const UserWalletSection = () => {
  const { getRouteKey } = useRouter();
  const navigate = useNavigate();
  const isCurrentPageIsBilling = location.pathname.includes("cart-billing");
  const { execute: fetchCartList } = useCartListAPI();
  const isCartList = location.pathname.includes("cart-list");
  const { customerId } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id")).routeState.state as ICustomerProfileState;

  const handelSelect = (url: string, close: () => void) => {
    if (url === "/app/user-cart/cart-billing" && !isCurrentPageIsBilling) {
      window.open(`${url}/${customerId}?from_cart=true`, "_blank", "noopener,noreferrer");
    } else {
      navigate(`${url}/${customerId}?from_cart=true`);
    }
    close();
  };

  const handelClick = () => {
    const filterBody: ICartFilterBody = {
      cart_status: ["Unbilled"],
      start_date: null,
      end_date: null,
    };
    !isCartList && fetchCartList(filterBody, customerId);
  };

  return (
    <div className={clsx("relative text-right")}>
      <Menu as="div" className="relative inline-block text-left">
        {({ close }) => (
          <>
            <div>
              <Menu.Button className="flex justify-between items-center text-sm text-[#FF0000]" onClick={handelClick}>
                <IoMdArrowDropdown className="w-4 h-4 text-gray-600 ml-2 cursor-pointer" />
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute mt-2 z-30 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
                <div className="p-3 flex flex-col gap-2 rounded-lg">
                  <RBACFlag actionId="CREDIT_LIST">
                    <p
                      onClick={() => handelSelect("/app/user-cart/credit-list", close)}
                      className="border-b pb-1 hover:text-green-500 hover:border-green-500 cursor-pointer"
                    >
                      Wallet
                    </p>
                  </RBACFlag>
                  <RBACFlag actionId="CART_BILLING">
                    <p
                      onClick={() => handelSelect("/app/user-cart/cart-billing", close)}
                      className="border-b pb-1 hover:text-green-500 hover:border-green-500 cursor-pointer"
                    >
                      Payment
                    </p>
                  </RBACFlag>
                  <RBACFlag actionId="INVOICE_LIST">
                    <p
                      onClick={() => handelSelect("/app/user-cart/invoice-list", close)}
                      className="border-b pb-1 hover:text-green-500 hover:border-green-500 cursor-pointer"
                    >
                      Old Invoices
                    </p>
                  </RBACFlag>
                  <RBACFlag actionId="DEBIT_NOTE">
                    <p
                      onClick={() => handelSelect("/app/user-cart/debit-note", close)}
                      className="border-b pb-1 hover:text-green-500 hover:border-green-500 cursor-pointer"
                    >
                      Debit Note
                    </p>
                  </RBACFlag>
                  <RBACFlag actionId="CREDIT_LIST">
                    <p
                      onClick={() => handelSelect("/app/user-cart/credit-note", close)}
                      className="border-b pb-1 hover:text-green-500 hover:border-green-500 cursor-pointer"
                    >
                      Credit Note
                    </p>
                  </RBACFlag>
                  <RBACFlag actionId="TRANSACTION_HISTORY">
                    <p
                      onClick={() => handelSelect("/app/user-cart/transaction-history", close)}
                      className="border-b pb-1 hover:text-green-500 hover:border-green-500 cursor-pointer"
                    >
                      Transactions
                    </p>
                  </RBACFlag>
                </div>
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
    </div>
  );
};

export default UserWalletSection;
